import { render, staticRenderFns } from "./ImportReportJsonComponent.vue?vue&type=template&id=b1852a90&"
import script from "./ImportReportJsonComponent.vue?vue&type=script&lang=js&"
export * from "./ImportReportJsonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports